// A saved drag-and-drop answer is JSON mapping each drop field id to a
// space-separated string of option guids. Rows have been found holding other
// shapes (such as grouping's {guid: true}), so bad JSON, a non-object, or a
// value that isn't a string is dropped and a malformed answer reads as
// unanswered. Mirrors load_answer in assessment/questions/ngn_dragdrop.py.
export function parseDragDropAnswer(answer) {
  if (typeof answer !== 'string') return {}
  let parsed
  try { parsed = JSON.parse(answer) } catch { return {} }
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {}
  const result = {}
  for (const [fieldId, guids] of Object.entries(parsed)) {
    if (fieldId && typeof guids === 'string') result[fieldId] = guids
  }
  return result
}
